import { atom } from 'nanostores';

const PROJECT_INPUT_TOKENS_STORAGE_PREFIX = 'dualite_project_input_tokens:';

interface ProjectInputTokenUsage {
  projectId: string;
  inputTokens: number;
}

export const projectInputTokenUsageStore = atom<ProjectInputTokenUsage | null>(null);

function getStorageKey(projectId: string) {
  return `${PROJECT_INPUT_TOKENS_STORAGE_PREFIX}${projectId}`;
}

export function loadProjectInputTokens(projectId: string | undefined) {
  if (typeof window === 'undefined' || !projectId) {
    projectInputTokenUsageStore.set(null);
    return;
  }

  try {
    const storedValue = localStorage.getItem(getStorageKey(projectId));
    const inputTokens = storedValue === null ? Number.NaN : Number.parseInt(storedValue, 10);

    projectInputTokenUsageStore.set(
      Number.isFinite(inputTokens) && inputTokens >= 0 ? { projectId, inputTokens } : null,
    );
  } catch {
    projectInputTokenUsageStore.set(null);
  }
}

export function saveProjectInputTokens(projectId: string | undefined, inputTokens: number) {
  if (!projectId || !Number.isFinite(inputTokens) || inputTokens < 0) {
    return;
  }

  const normalizedInputTokens = Math.round(inputTokens);
  projectInputTokenUsageStore.set({ projectId, inputTokens: normalizedInputTokens });

  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(getStorageKey(projectId), String(normalizedInputTokens));
    } catch {
      // The in-memory value still keeps the current project header up to date.
    }
  }
}
